import { ExternalLink } from 'lucide-react';

const Footer = () => {
  const socials = [
    { label: 'Youtube', href: 'https://www.youtube.com/@ikeda0110' },
    { label: '公式LINEアカウント', href: 'https://lin.ee/QGNguZ2' },
    { label: 'Googleマップ', href: 'https://maps.app.goo.gl/Q2VAu9NZB1C4Sn5KA' },
    { label: 'Facebook', href: 'https://www.facebook.com/kokoronoishi/' },
    { label: 'Instagram', href: 'https://www.instagram.com/ikeda.sekizai/' },
  ];

  return (
    <footer className="bg-white border-t border-stone-200 mt-20" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">サイトフッター</h2>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-8 items-start">
          <div>
            <img 
              src="images/logo.png" 
              alt="池田石材興業" 
              className="h-24 w-auto mb-4" 
            />
            <p className="mt-2 text-stone-600 text-sm">新潟・長野の墓じまい相談窓口</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-stone-800 mb-3">SNSアカウント</p>
            <ul className="space-y-2">
              {socials.map((s) => (
                <li key={s.href}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-stone-600 hover:text-amber-600 transition-colors"
                    aria-label={`${s.label}を開く（新しいタブ）`}
                  >
                    {s.label}
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <hr className="my-8 border-stone-200" />
        <p className="text-xs text-stone-500">Copyright © 2025 Ikeda Sekizai. All right reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
